import {scrollTo} from "@/functions/scrollTo";
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const clientPortalRouter = new Router({
	mode: "history",
	routes: [
		{
			path: "/sign-up/:client",
			name: "register.create",
			component: () => import("./views/auth/RegisterCreate"),
			meta: {
				layout: "Auth",
				setJustLoggedIn: true,
			},
		},
		{
			path: "/login",
			name: "login",
			component: () => import("./views/auth/Login"),
			meta: {
				layout: "Auth",
				setJustLoggedIn: true,
			},
			params: {
				includePasswordResetMessage: false,
			},
		},
		{
			path: "/password/reset",
			name: "password.requestToken",
			component: () => import("./views/auth/PasswordResetRequest"),
			meta: {
				layout: "Auth",
			},
		},
		{
			path: "/password/reset/:token",
			name: "password.reset",
			component: () => import("./views/auth/PasswordReset"),
			meta: {
				layout: "Auth",
			},
		},
		{
			path: "/guest/:client/client-contract/:clientContract",
			name: "clientContract",
			component: () => import("./views/guest/ClientContract.vue"),
			meta: {
				layout: "GuestDocument",
			},
		},
		{
			path: "/guest/:client/id-check/:idCheck",
			name: "idCheck",
			component: () => import("./views/guest/IdCheck.vue"),
			meta: {
				layout: "Guest",
			},
		},
		{
			path: "/",
			name: "dashboard",
			component: () => import("./views/Dashboard"),
		},
		{
			path: "/documents",
			name: "documents.index",
			component: () => import("./views/Documents"),
		},
		{
			path: "/invoices",
			name: "invoices.index",
			component: () => import("./views/invoices/Index"),
		},
		{
			path: "/invoices/:invoice",
			name: "invoices.show",
			component: () => import("./views/Invoices/Show"),
		},
		{
			path: "/buy",
			name: "quote.create.buy",
			component: () => import("./views/Quote"),
		},
		{
			path: "/sell",
			name: "quote.create.sell",
			component: () => import("./views/Quote"),
		},
		{
			path: "/instructions/:instruction/protocol-pack/:form",
			name: "protocolForm.edit",
			component: () => import("./views/protocolPack/Edit"),
		},
		{
			path: "*",
			component: () => import("../../views/errors/Error404.vue"),
		},
	],
});

clientPortalRouter.beforeEach((to, from, next) => {
	scrollTo(0, {
		context: "[role=main]",
	});
	window.app.$store?.commit("errorsStore/RESET");
	next();
});

clientPortalRouter.afterEach((to, from, next) => {
	window.app.$store?.commit("authStore/SET_JUST_LOGGED_IN", from.meta?.setJustLoggedIn || false);
});

export default clientPortalRouter;
